import styled from 'styled-components';

export const DatePickerWrapper = styled.div`
    input {
        width: 5rem;
        text-align: center;
    }
`;
